import { redirect } from 'react-router-dom';
import { queryClient, getSubscriptionQuery } from '../../shared/queries';
import { SubscriptionPlans } from './entity';
import { getAuthState } from '@shared/auth/AuthContext';

const requiredSubscriptionLoader = async (allowedPlans: SubscriptionPlans[]) => {
  const { token, ready, isDemo } = getAuthState();

  if (isDemo || !ready || !token) {
    return null;
  }

  try {
    const subscription = await queryClient.fetchQuery(getSubscriptionQuery());

    if (!subscription || !allowedPlans.includes(subscription.plan)) {
      throw redirect(window.location.origin + '/hairdresser/subscription?action=change');
    }

    return null;
  } catch (error) {
    if (error instanceof Error && error.message.includes('Token getter not initialized')) {
      return null;
    }

    if (error instanceof Response) {
      throw error;
    }
    throw new Response('Nepodařilo se načíst data', { status: 500 });
  }
};

export default requiredSubscriptionLoader;
